import { createSelector } from 'reselect'
import { createBasicSelector } from 'util/redux'
import { selectRequestByType } from 'ducks/requests/selectors'
import { emptyObj } from 'util/objects'

import createCachedSelector from 're-reselect'

import {
  FETCH_CUSTOMER_RATING_SETTINGS,
  UPSERT_CUSTOMER_RATING_SETTINGS,
} from './types'

export function selectBase(state) {
  return state.customerRatingSettings
}

export const selectCustomerRatingSettingsById = createBasicSelector(
  selectBase,
  base => base.byId
)

export const selectCustomerRatingSettings = createSelector(
  selectCustomerRatingSettingsById,
  byId => Object.values(byId)
)

export const selectCustomerRatingSettingById = createCachedSelector(
  selectCustomerRatingSettingsById,
  (state, byId) => byId,
  (byId, settingId) => byId[settingId] || emptyObj
)((state, settingId) => `${settingId || 'unknown'}`)

export const selectIsLoadingCustomerRatingSettings = state =>
  selectRequestByType(state, FETCH_CUSTOMER_RATING_SETTINGS).loading

export const selectHasLoadedCustomerRatingSettings = state =>
  selectRequestByType(state, FETCH_CUSTOMER_RATING_SETTINGS).loaded

export const selectIsLoadingCustomerRatingSetting = state =>
  selectRequestByType(state, UPSERT_CUSTOMER_RATING_SETTINGS).loading
